import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	childIssuesMetadataTooltip: {
		id: 'backlog.card-list.card.child-issues-metadata-tooltip',
		defaultMessage:
			'{complete} of {total, plural, one {# child issue} other {# child issues}} complete',
		description:
			'Tooltip around an icon indicating how many issues are complete out of total child issues',
	},
	cardFocusScreenreaderText: {
		id: 'backlog.card-list.card.card-focus-screenreader-text',
		defaultMessage:
			'Use the enter key to load the issue view. Use the space key to move the issue.',
		description: 'The message announced by screenreaders when a backlog card is focused',
	},
	epicLozenge: {
		id: 'backlog.card-list.card.epic-lozenge',
		defaultMessage: 'epic',
		description: 'Epic',
	},
	flaggedTooltip: {
		id: 'backlog.card-list.card.flagged-tooltip',
		defaultMessage: 'Flagged',
		description: 'Tooltip around an icon indicating whether an issue is flagged',
	},
	addFlagTooltip: {
		id: 'backlog.card-list.card.add-flag-tooltip',
		defaultMessage: 'Add Flag',
		description: 'Tooltip around an icon indicating to add flag inline',
	},
	storyPointsTooltip: {
		id: 'backlog.card-list.card.story-points-tooltip',
		defaultMessage: 'Story points',
		description: 'Tooltip around story point field',
	},
	storyPointsAriaLabel: {
		id: 'backlog.card-list.card.story-points-aria-label',
		defaultMessage: 'Story points: {storyPointValue}',
		description: 'Accessibility label for story point field',
	},
	storyPointsAriaLabelNullValue: {
		id: 'backlog.card-list.card.story-points-aria-label-null-value',
		defaultMessage: 'No estimate set',
		description: 'Accessibility label for story point field',
	},
	statusTooltip: {
		id: 'backlog.card-list.card.status-tooltip',
		defaultMessage: 'Status',
		description: 'Tooltip around status field',
	},
	numberOfChildrenText: {
		id: 'backlog.card-list.card.number-of-children-text',
		defaultMessage: '{numberOfChildren} {numberOfChildren, plural, one {subtask} other {subtasks}}',
		description: 'Text to display number of linked subtasks',
	},
	parentKeyText: {
		id: 'backlog.card-list.card.parent-key-text',
		defaultMessage: 'Subtask of {parentKey}',
		description:
			'Text to display parent key and on tooltip if subtask is not attached to the parent',
	},
	cardGroupToggleExpandedAriaLabel: {
		id: 'backlog.card-list.card.card-group-toggle-expanded-aria-label',
		defaultMessage: 'Hide subtasks for {issueKey} {summary}',
		description:
			'Accessibility label for when a subtask group is expanded. {issueKey} will be replaced with the issue key. {summary} will be replaced with the issue summary.',
	},
	cardGroupToggleCollapsedAriaLabel: {
		id: 'backlog.card-list.card.card-group-toggle-collapsed-aria-label',
		defaultMessage: 'Show subtasks for {issueKey} {summary}',
		description:
			'Accessibility label for when a subtask group is collapsed. {issueKey} will be replaced with the issue key. {summary} will be replaced with the issue summary.',
	},
	cardGroupToggleTooltipExpand: {
		id: 'backlog.card-list.card.card-group-toggle-tooltip-expand',
		defaultMessage: 'Expand',
		description: 'Tooltip shown on chevron when clicking on it will expand to show the subtasks',
	},
	cardGroupToggleTooltipCollapse: {
		id: 'backlog.card-list.card.card-group-toggle-tooltip-collapse',
		defaultMessage: 'Collapse',
		description: 'Tooltip shown on chevron when clicking on it will collapse to hide the subtasks',
	},
	childIssuesMetadataTooltipIssueTermRefresh: {
		id: 'backlog.card-list.card.child-issues-metadata-tooltip-issue-term-refresh',
		defaultMessage:
			'{complete} of {total, plural, one {# child issue} other {# child issues}} complete',
		description:
			'Tooltip around an icon indicating how many issues are complete out of total child issues',
	},
	cardFocusScreenreaderTextIssueTermRefresh: {
		id: 'backlog.card-list.card.card-focus-screenreader-text-issue-term-refresh',
		defaultMessage:
			'Use the enter key to load the issue view. Use the space key to move the issue.',
		description: 'The message announced by screenreaders when a backlog card is focused',
	},
	cardGroupToggleExpandedAriaLabelIssueTermRefresh: {
		id: 'backlog.card-list.card.card-group-toggle-expanded-aria-label-issue-term-refresh',
		defaultMessage: 'Hide subtasks for {issueKey} {summary}',
		description:
			'Accessibility label for when a subtask group is expanded. {issueKey} will be replaced with the issue key. {summary} will be replaced with the issue summary.',
	},
	cardGroupToggleCollapsedAriaLabelIssueTermRefresh: {
		id: 'backlog.card-list.card.card-group-toggle-collapsed-aria-label-issue-term-refresh',
		defaultMessage: 'Show subtasks for {issueKey} {summary}',
		description:
			'Accessibility label for when a subtask group is collapsed. {issueKey} will be replaced with the issue key. {summary} will be replaced with the issue summary.',
	},
	cardCheckboxLabel: {
		id: 'backlog.card-list.card.checkbox.label',
		defaultMessage: 'Select {cardKey} {summary}',
		description: 'Accessibility label for a card checkbox to select a card to allow bulk edit',
	},
});
